import { render, staticRenderFns } from "./CreatePromotion.vue?vue&type=template&id=3d0efd42&"
import script from "./CreatePromotion.vue?vue&type=script&lang=ts&"
export * from "./CreatePromotion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports